module.exports = __webpack_public_path__ + "static/img/basic03.5541e29e.png";